import React, { useState, useEffect } from "react";
import axios from "axios";
import PriceCallService from "../home/PriceCallService";
import { Alert, Snackbar } from "@mui/material";

const PriceCal = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [assembly, setAssembly] = useState("Local");
  const [milage, setMilage] = useState("");
  const [makeName, setMakeName] = useState(null);
  const [modelName, setModelName] = useState("");
  const [yearName, setYearName] = useState("");
  const [variant, setVariant] = useState("");
  const [registeredIn, setRegisteredIn] = useState("");
  const [transmission, setTransmission] = useState("");
  const [vehicleFuel, setVehicleFuel] = useState("");
  const [categoryName, setCategoryName] = useState("");
  const [calculate, setCalculate] = useState({});
  const [error, setError] = useState("");
  const [make, setMake] = useState(null);
  const [getModel, setGetModel] = useState(null);
  const [makeId, setMakeId] = useState("");
  const [modelYear, setModelYear] = useState(null);
  const [variantList, setVariantList] = useState([]);
  const [toogle, setToogle] = useState(false);
  const [errorToast, setErrorToast] = React.useState(false);

  useEffect(() => {
    const fetchMake = async () => {
      try {
        const response = await axios.get(`${baseUrl}/byMake`);

        setMake(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchMake();
  }, []);

  const handleMakeChange = (e) => {
    const selectedMake = make.find((item) => item.makeName === e.target.value);
    if (selectedMake) {
      setMakeId(selectedMake.makeId);
    } else {
      setMakeId("");
    }
    setMakeName(e.target.value);
  };

  useEffect(() => {
    const fetchModel = async () => {
      try {
        const response = await axios.get(`${baseUrl}/model-by-make`, {
          params: {
            make_id: makeId,
          },
        });

        setGetModel(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (makeId) {
      fetchModel();
    } else {
      setGetModel([]);
    }
  }, [makeId]);

  useEffect(() => {
    const fetchYear = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getModelYear`);

        setModelYear(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchYear();
  }, []);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarient`, {
          params: {
            variant_id: variant,
          },
        });

        setVehicleFuel(response.data?.engine_type);
        setCategoryName(response.data?.engine_capacity);
        setTransmission(response.data?.transmission);
        setAssembly(response.data?.assembly);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (variant) {
      fetchFeatures();
    } else if (variantList.length === 0) {
      setTransmission(false);
    } else {
    }
  }, [modelName, variant, variantList.length, yearName]);

  useEffect(() => {
    const fetchVariant = async () => {
      try {
        const response = await axios.get(`${baseUrl}/getVarientList`, {
          params: {
            modelId: modelName,
            yearId: yearName,
          },
        });

        setVariantList(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (yearName) {
      fetchVariant();
    } else {
      setVariantList([]);
    }
  }, [modelName, yearName]);

  const AdSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");

      const formData = new FormData();

      formData.append("make_id", makeId);
      formData.append("model_id", modelName);
      formData.append("year_id", yearName);
      formData.append("variant_id", variant);

      formData.append("status", 2);

      const response = await axios.post(
        `${baseUrl}/findcarsuggestionprice`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setCalculate(response?.data?.data);
      setToogle(true);
    } catch (err) {
      // setError(err?.response?.data);
      setErrorToast(true);
    }
  };

  return (
    <>
      <Snackbar
        open={errorToast}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          Something went wrong. Please try again.
        </Alert>
      </Snackbar>
      <div className=" w-100 bg-light pt-5 ">
        <div className="container col-10 ">
          <h1 className="fs-5 ">
            Used Car Price Calculator <span className="fs-6">(beta)</span>{" "}
          </h1>
          <p className="fontClass ">
            Get a realistic price estimate of a used car based on extensive
            market research.
          </p>
        </div>

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-11 col-md-11 bg-white mb-5 border p-4 p-md-5 rounded-3">
              <div className="d-flex justify-content-between w-100 gap-5">
                <div className="w-md-75 w-100">
                  <h3 className="text-start fs-4">Calculate</h3>
                  <p className="text-start fontClass ">
                    All fields marked with * are mandatory
                  </p>

                  <form onSubmit={AdSubmit} className="postAdForm ">
                    {error && <p>{error}</p>}
                    <div className="row">
                      <div className=" col-12 col-md-6 mb-3 ">
                        <label
                          for="vehicleMake"
                          className="whitespace-nowrap w-50  d-inline font-class "
                        >
                          Select Make*
                        </label>
                        <select
                          className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          id="vehicleMake"
                          aria-label="Default select example"
                          required
                          value={makeName}
                          onChange={handleMakeChange}
                        >
                          <option className="font-class" selected value=" ">
                            Make
                          </option>
                          {make &&
                            make.map((item) => (
                              <option
                                className="font-class"
                                key={item.makeId}
                                value={item.makeName}
                              >
                                {item.makeName}
                              </option>
                            ))}
                        </select>
                        <div
                          id="CityHelp"
                          className="form-text text-center fontClass"
                        >
                          Mention your vehicle's make (e.g. Honda)
                        </div>
                      </div>
                      {makeName !== " " && (
                        <div className=" col-12 col-md-6 mb-3">
                          {makeId && getModel?.length > 0 ? (
                            <div className="mb-3 w-100">
                              <label
                                for="vehicleModel"
                                className="whitespace-nowrap w-50  d-inline font-class"
                              >
                                Model*
                              </label>
                              <select
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleModel"
                                aria-label="Default select example"
                                required
                                value={modelName}
                                onChange={(e) => setModelName(e.target.value)}
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select {makeName && makeName} Model
                                </option>
                                {getModel &&
                                  getModel.map((item) => (
                                    <option
                                      className="font-class"
                                      key={item.modelId}
                                      value={item.modelId}
                                    >
                                      {item.modelName}
                                    </option>
                                  ))}
                              </select>

                              <div
                                id="CityHelp"
                                className="form-text text-center fontClass"
                              >
                                Mention your vehicle's Model (e.g. Civic)
                              </div>
                            </div>
                          ) : (
                            <div className="col-12 col-md-6 mb-3 w-100">
                              <label
                                for="vehicleModel"
                                className="whitespace-nowrap  w-50 d-inline font-class"
                              >
                                Model*
                              </label>
                              <select
                                className="form-select w-md-50 bg-white  col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleModel"
                                aria-label="Default select example"
                                required
                                disabled
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select {makeName && makeName} Model
                                </option>
                              </select>

                              <div
                                id="CityHelp"
                                className="form-text fontClass text-center text-danger"
                              >
                                Select make first
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {modelName && modelName !== " " && (
                        <div className=" col-12 col-md-6 mb-3">
                          {makeId &&
                          modelName !== " " &&
                          modelYear?.length > 0 ? (
                            <div className="mb-3 w-100">
                              <label
                                for="vehicleYear"
                                className="whitespace-nowrap   w-50 d-inline font-class"
                              >
                                Year*
                              </label>
                              <select
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleYear"
                                aria-label="Default select example"
                                required
                                value={yearName}
                                onChange={(e) => setYearName(e.target.value)}
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select {modelName && modelName} Year
                                </option>
                                {modelYear &&
                                  modelYear.map((item) => (
                                    <option
                                      className="font-class"
                                      key={item.yearId}
                                      value={item.yearId}
                                    >
                                      {item.year}
                                    </option>
                                  ))}
                              </select>

                              <div
                                id="CityHelp"
                                className="form-text text-center fontClass"
                              >
                                Mention your vehicle's Year (e.g. 2018)
                              </div>
                            </div>
                          ) : (
                            <div className="col-12 col-md-6 mb-3">
                              <label
                                for="vehicleYear"
                                className="whitespace-nowrap w-50 d-inline font-class"
                              >
                                Year*
                              </label>
                              <select
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleYear"
                                aria-label="Default select example"
                                required
                                disabled
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select Year
                                </option>
                              </select>
                              <div
                                id="CityHelp"
                                className="form-text fontClass text-center text-danger"
                              >
                                Select Model first
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {yearName && yearName !== " " && (
                        <div className="col-12 col-md-6 mb-3">
                          {modelName &&
                          yearName !== " " &&
                          variantList?.length > 0 ? (
                            <div className="mb-3 w-100">
                              <label
                                for="vehicleYear"
                                className="whitespace-nowrap w-50   d-inline font-class"
                              >
                                Variant*
                              </label>
                              <select
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleYear"
                                aria-label="Default select example"
                                value={variant}
                                onChange={(e) => setVariant(e.target.value)}
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select {modelName && modelName}{" "}
                                  {yearName && yearName} Variant
                                </option>
                                {variantList &&
                                  variantList.map((item) => (
                                    <option
                                      className="font-class"
                                      key={item.featuresId}
                                      value={item.featuresId}
                                    >
                                      {item.featureName}
                                    </option>
                                  ))}
                              </select>

                              <div
                                id="CityHelp"
                                className="form-text text-center fontClass"
                              >
                                Mention {modelName && modelName}{" "}
                                {yearName && yearName} Variant
                              </div>
                            </div>
                          ) : modelName &&
                            yearName !== " " &&
                            variantList?.length === 0 ? (
                            <>
                              <label
                                for="vehicleYear"
                                className="whitespace-nowrap w-50 d-inline font-class"
                              >
                                Variant
                              </label>
                              <input
                                type="text"
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="varient"
                                aria-describedby="VarientHelp"
                                value={variant}
                                onChange={(e) => setVariant(e.target.value)}
                              />
                              <div
                                id="VarientHelp"
                                className="form-text text-center fontClass text-danger"
                              >
                                Mention {modelName && modelName}{" "}
                                {yearName && yearName} Variant
                              </div>
                            </>
                          ) : (
                            <div className="col-12 col-md-6 mb-3">
                              <label
                                for="vehicleYear"
                                className="whitespace-nowrap w-50  margin d-inline font-class"
                              >
                                Variant
                              </label>
                              <select
                                className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                id="vehicleYear"
                                aria-label="Default select example"
                                required
                                disabled
                              >
                                <option
                                  className="font-class"
                                  selected
                                  value=" "
                                >
                                  Select Variant
                                </option>
                              </select>
                              <div
                                id="CityHelp"
                                className="form-text fontClass text-center text-danger"
                              >
                                Select Year first
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      <div className="col-12 col-md-6 mb-3">
                        <label
                          for="vehicleKM"
                          className="whitespace-nowrap w-50 d-inline font-class"
                        >
                          Mileage* (KM)
                        </label>
                        <input
                          type="number"
                          className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          id="vehicleKM"
                          placeholder="Mileage"
                          min="0"
                          required
                          value={milage}
                          onChange={(e) => setMilage(e.target.value)}
                        />
                      </div>

                      {yearName && yearName !== " " && (
                        <>
                          {vehicleFuel !== "Electric" && (
                            <div className="col-12 col-md-6 mb-3">
                              <div className="mb-3 w-100">
                                <label
                                  for="categoryName"
                                  className="whitespace-nowrap w-50 d-inline font-class"
                                >
                                  Engine Size* (cc)
                                </label>

                                <input
                                  type="text"
                                  className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                  id="categoryName"
                                  aria-describedby="categoryName"
                                  placeholder="Engine Capacity (cc)"
                                  required
                                  value={categoryName}
                                  onChange={(e) =>
                                    setCategoryName(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          )}
                        </>
                      )}

                      <div className="col-12 col-md-6 mb-3">
                        <label
                          for="vehicleTransmission"
                          className="whitespace-nowrap w-50  d-inline font-class"
                        >
                          Transmission
                        </label>
                        <select
                          className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          id="vehicleTransmission"
                          aria-label="Default select example"
                          required
                          value={transmission}
                          onChange={(e) => setTransmission(e.target.value)}
                        >
                          <option className="font-class" selected value=" ">
                            Select
                          </option>
                          <option className="font-class" value="Automatic">
                            Automatic
                          </option>
                          <option className="font-class" value="Manual">
                            Manual
                          </option>
                        </select>
                      </div>

                      <div className="col-12 col-md-6 mb-3 ">
                        <label
                          for="vehicleAssembly"
                          className="whitespace-nowrap w-50  d-inline font-class"
                        >
                          Assembly
                        </label>
                        <select
                          className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                          id="vehicleAssembly"
                          aria-label="Default select example"
                          required
                          value={assembly}
                          onChange={(e) => setAssembly(e.target.value)}
                        >
                          <option className="font-class" selected value=" ">
                            Select Assembly
                          </option>
                          <option className="font-class" value="Local">
                            Local
                          </option>
                          <option className="font-class" value="Imported">
                            Imported
                          </option>
                        </select>
                      </div>

                      <div className="col-12 col-md-6 mb-3">
                        <div className="mb-3 w-100">
                          <label
                            for="post-registeration"
                            className="whitespace-nowrap w-50  d-inline font-class"
                          >
                            Registered In
                          </label>
                          <select
                            className="form-select w-md-50   col-span-2 d-inline  max-w-xs mx-2  border border-gray-300 rounded-md shadow-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            id="post-registeration"
                            aria-label="Default select example"
                            required
                            placeholder="Registered In"
                            value={registeredIn}
                            onChange={(e) => setRegisteredIn(e.target.value)}
                          >
                            <option className="font-class" selected value=" ">
                              Select
                            </option>
                            <option className="font-class" value="Unregistered">
                              Unregistered
                            </option>
                            <option className="font-class" value="Islamabad">
                              Islamabad
                            </option>
                            <option className="font-class" value="Sindh">
                              Sindh
                            </option>
                            <option className="font-class" value="Punjab">
                              Punjab
                            </option>
                            <option className="font-class" value="KPK">
                              KPK
                            </option>
                            <option className="font-class" value="Balochistan">
                              Balochistan
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <hr />

                    <div className="text-center mb-3 ">
                      <button
                        type="submit"
                        className="btn fw-secondary postFormBtn"
                      >
                        Calculate
                      </button>

                      {/* <button
    type="submit"
    className="btn fw-secondary postFormBtn"
    disabled={postDisabled}
    onClick={handleSubmitButton}
    style={
      postDisabled
        ? { backgroundColor: "#b8050550" }
        : { backgroundColor: "#b80505" }
    }
  >
    {postDisabled ? "Complete to continue" : "Post"}
  </button> */}
                    </div>
                  </form>

                  {toogle && (
                    <div className="border rounded-2  text-center">
                      <h2 className="mt-5 fs-md-3 fs-5">
                        PKR {calculate?.minPrice} 
                      </h2>
                      <p className="d-md-font-class font-class2">
                        PKR {calculate?.minPrice}
                      </p>

                      <p className="mt-4 d-md-font-class font-class2">
                        Recommended Price Range
                      </p>

                      <div
                        style={{ width: "100%", height: "10px" }}
                        className="progress w-75 mx-auto "
                      >
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{
                            width: "100%",
                            height: "10px",
                            background:
                              "linear-gradient(to right, yellow 0%, green 50%, orange 100%)",
                          }}
                          aria-valuenow="100"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>

                      <div className="d-flex justify-content-between w-75 mx-auto mt-2">
                        <div className="d-md-font-class font-class2">
                          Min
                          <p>PKR {calculate?.minPrice} </p>
                        </div>
                        <div className="d-md-font-class font-class2">
                          Max
                          <p>PKR {calculate?.maxPrice}</p>
                        </div>
                      </div>
                    </div>
                  )}

                  <p className="font-class2 text-success mt-3">
                    Disclaimer: Used car valuations are based on sophisticated
                    algorithms, extensive research and market data collection.
                    Actual prices may vary based on overall condition of car,
                    extra modifications and market conditions or other
                    circumstances pertinent to a particular car. PakWheels
                    assumes no responsibility for errors and omissions.
                  </p>
                </div>

                <div className="w-px widthclass d-none d-md-inline "></div>

                <div className="w-25 text-center d-md-inline d-none">
                  <img src="/carlogo.jpg" alt="logoImage" />
                  <h2 className="fs-6 mt-3 w-100 col-md-4">
                    Know What's the Best Selling Price for Your Car
                  </h2>
                  <p className="font-class2 mt-3">
                    Know how much your car is worth with used car price
                    valuation tool. It provides realistic price estimate that
                    are based on extensive market research.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <h1 className="  mt-5 mb-5  mt-md-5 fs-4 ms-md-5 ms-xl-4">
          FameWheels Offerings
        </h1>
        <div className="marginClass">
          <PriceCallService />
        </div>
      </div>
    </>
  );
};

export default PriceCal;
